/**
 * Phase 1 partner auth — access token held in memory only (not localStorage).
 * Residual risk: /auth/token is still mintable with a known userId.
 */

let accessToken: string | null = null;
let expiresAtMs = 0;

export function getPartnerAccessToken(): string | null {
  if (!accessToken) return null;
  if (expiresAtMs && Date.now() >= expiresAtMs) {
    clearPartnerAccessToken();
    return null;
  }
  return accessToken;
}

export function setPartnerAccessToken(token: string, expiresInSeconds: number): void {
  accessToken = token;
  // Refresh slightly before expiry
  const skewMs = 30_000;
  expiresAtMs = Date.now() + Math.max(0, expiresInSeconds * 1000 - skewMs);
}

export function clearPartnerAccessToken(): void {
  accessToken = null;
  expiresAtMs = 0;
}

export const AUTH_TOKEN_PATH = '/auth/token';
